// Badge.js
import React from "react";
import "./Badge.css";

const StatusBadge = ({
  status,
  type = "custom",
  variant,
  pill = false,
  className = "",
  style = {},
}) => {
  const getColorVariant = (status, type) => {
    if (variant) return variant;

    if (type === "visible" && typeof status === "boolean") {
      return status ? "warning" : "success"; // true = hidden, false = visible
    }
    // Boolean status handling
    if (type === "status" && typeof status === "boolean") {
      return status ? "success" : "danger";
    }

    const normalizeStatus = (value) =>
      String(value || "")
        .toLowerCase()
        .replace(/\s+/g, "") // removes hidden spaces, tabs, newlines
        .trim();

    const statusKey = normalizeStatus(status);
    const statusLower = statusKey.toLowerCase();
    if (type === "order") {
      const orderStatusMap = {
        ordered: "warning",
        preparing: "secondary",
        ready: "primary",
        completed: "success",
        cancelled: "danger",
        ongoing: "info",
      };
      return orderStatusMap[statusLower] || "secondary";
    }

    if (type === "payment") {
      const paymentStatusMap = {
        paid: "success",
        pending: "warning",
        failed: "danger",
        processing: "secondary",
        refunded: "primary",
        partiallyrefunded: "secondary",
        ordercancelled: "danger",
        completed: "success",
        chargeback: "secondary",
      };
      return paymentStatusMap[statusLower] || "danger";
    }

    if (type === "status") {
      const activeInactive = {
        active: "success",
        inactive: "danger",
      };
      return activeInactive[statusLower] || "secondary";
    }

    if (type === "visible") {
      const activeInactive = {
        visible: "success",
        hidden: "warning",
      };
      return activeInactive[statusLower] || "secondary";
    }

    if (type === "table") {
      const tableStatusMap = {
        available: "success",
        occupied: "danger",
        reserved: "dark",
        unavailable: "primary",
        undermaintenance: "info",
      };
      return tableStatusMap[statusLower] || "secondary";
    }

    return "secondary";
  };

  const colorVariant = getColorVariant(status, type);
  const badgeClassName = `badge badge-${colorVariant} ${
    pill ? "badge-pill" : ""
  } ${className}`.trim();

  return (
    <span className={badgeClassName} style={style}>
      {type === "visible" && typeof status === "boolean"
        ? status
          ? "Hidden"
          : "Visible"
        : type === "status" && typeof status === "boolean"
        ? status
          ? "Active"
          : "Inactive"
        : status || "No Data"}
    </span>
  );
};

export default StatusBadge;
